import { NgModule } from '@angular/core';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { localStorageSync } from 'ngrx-store-localstorage';
import { AuthEffects } from './auth/auth.effects';
import {
  reducers,
  storeAuthKey,
  storeAvailableRoomsKey,
  storeBookingFormKey,
  storeBookingsKey,
} from './reducers';
import { BookingsScope } from './bookings/bookings.state';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../../../environments/environment';
import { RoomsEffects } from './rooms/rooms.effects';
import { AmenitiesEffects } from './amenities/amenities.effects';
import { UsersEffects } from './users/users.effects';
import { InvitesEffects } from './invites/invites.effects';
import { RatesEffects } from './rates/rates.effects';
import { LayoutsEffects } from './layouts/layouts.effects';
import { EventTypesEffects } from './event-types/event-types.effects';
import { BookingsEffects } from './bookings/bookings.effects';
import { RoomAvailabilitiesEffects } from './room-availabilities/room-availabilities.effects';
import { InvoicingEffects } from './invoicing/invoicing.effects';
import { CommunicationTemplatesEffects } from './communication-templates/communication-templates.effects';
import { CancelConditionsEffects } from './cancel-conditions/cancel-conditions.effects';
import { AvailableRoomsEffects } from './available-rooms/available-rooms.effects';
import { CouponsEffects } from './coupons/coupons.effects';
import { UiEffects } from './ui/ui.effects';
import { BuildingsEffects } from './buildings/buildings.effects';
import { CustomFieldsEffects } from './custom-fields/custom-fields.effects';
import { BookingFormEffects } from './booking-form/booking-form.effects';

export function localStorageSyncReducer(
  reducer: ActionReducer<any>,
): ActionReducer<any> {
  return localStorageSync({
    keys: [
      storeAuthKey,
      storeBookingFormKey,
      storeAvailableRoomsKey,
      {
        [storeBookingsKey]: [
          {
            [BookingsScope.All]: ['roomsFilter', 'displayMode'],
            [BookingsScope.Personal]: ['roomsFilter', 'displayMode'],
          },
        ],
      },
    ],
    rehydrate: true,
    restoreDates: false,
  })(reducer);
}

const metaReducers: Array<MetaReducer<any, any>> = [];
if (typeof window !== 'undefined') {
  metaReducers.push(localStorageSyncReducer);
}

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      AuthEffects,
      RoomsEffects,
      UsersEffects,
      InvitesEffects,
      AmenitiesEffects,
      RatesEffects,
      LayoutsEffects,
      EventTypesEffects,
      BookingsEffects,
      RoomAvailabilitiesEffects,
      InvoicingEffects,
      CommunicationTemplatesEffects,
      CancelConditionsEffects,
      AvailableRoomsEffects,
      CouponsEffects,
      UiEffects,
      BuildingsEffects,
      CustomFieldsEffects,
      BookingFormEffects,
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
  ],
  exports: [StoreModule],
})
export class NgrxModule {}
